export default "/_next/static/images/bec7e6b7e45918f8cb97f948f137284f.png";